module.exports = __webpack_public_path__ + "static/media/import_csv.47d234ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/import_csv.png
// module id = 1853
// module chunks = 0